import * as SliderPrimitive from "@radix-ui/react-slider";
import { cn } from "../../lib/utils";

export function Slider({ className, ...props }) {
  return (
    <SliderPrimitive.Root
      className={cn("relative flex w-full touch-none select-none items-center", className)}
      {...props}
    >
      <SliderPrimitive.Track className="relative h-1 w-full grow overflow-hidden rounded-full bg-[var(--soft-fill)]">
        <SliderPrimitive.Range className="absolute h-full bg-[#60a5fa]" />
      </SliderPrimitive.Track>
      <SliderPrimitive.Thumb className="block h-4 w-4 rounded-full border-2 border-[var(--surface)] bg-[#60a5fa] shadow transition-all focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#60a5fa]/50 disabled:pointer-events-none disabled:opacity-50 hover:scale-110" />
    </SliderPrimitive.Root>
  );
}
